export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";